import { render, staticRenderFns } from "./dfm-brokers-members.vue?vue&type=template&id=bfc686d4"
import script from "./dfm-brokers-members.vue?vue&type=script&lang=js"
export * from "./dfm-brokers-members.vue?vue&type=script&lang=js"
import style0 from "./dfm-brokers-members.vue?vue&type=style&index=0&id=bfc686d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/brokers-members-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fmembers%2Fdfm-brokers-members.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/brokers-members-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fmembers%2Fdfm-brokers-members.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default,CardWithImageBg: require('/vercel/path0/components/ui/CardWithImageBg.vue').default,LinkedIconCard: require('/vercel/path0/components/LinkedIconCard.vue').default,CtaImage: require('/vercel/path0/components/ui/cta-image.vue').default,BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default})
